<template>
  <div>
    <preloader :is-visible="false && loading"></preloader>
    <div class="uk-card uk-card-default">
      <!--шапка страницы-->
      <div class="uk-card-header" style="padding-top: 15px;padding-bottom: 15px;">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.table_title_admin_reports }}
              <span class="uk-label tm-label">Beta</span>
              <div style="width:300px"
                   class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                Вы видите тестовую версию отчетов. Данные могут быть не корректными на 100%. Просьба, если вы видите неточности/расхождения передать данные администратору.
              </div>
            </h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-grid uk-grid-small" data-uk-grid>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <!--Общая сводная таблица по неделям/месяцам-->
        <div class="uk-margin uk-animation-slide-bottom-small">
          <div class="tm-admin-report-title">
            Общая сводная таблица по неделям/месяцам
          </div>
          <ul class="uk-subnav uk-subnav-pill" data-uk-switcher="animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
            <li v-for="(tab, key) in tabs" :key="key" :class="tab.class">
              <a :href="'#' + key" @click="changeTab(key)">{{ tab.name }}</a>
            </li>
          </ul>
          <div class="uk-margin-top uk-background-muted">
            <!--опции-->
            <div class="uk-padding-xsmall uk-text-small">
              <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                <div>
                  Год
                </div>
                <div v-if="activeTab === 'weeks'">
                  <select v-model="selectedYearForWeeks" class="uk-select tm-form-small">
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                  </select>
                </div>
                <div v-if="activeTab === 'months'">
                  <select v-model="selectedYearForMonths" class="uk-select tm-form-small">
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                  </select>
                </div>
                <template v-if="activeTab === 'weeks' && weekRange">
                  <div>
                    Показать недели с
                  </div>
                  <div>
                    <select v-model="endWeek" class="uk-select tm-form-small">
                      <option v-for="week in weekRange" :key="week" :value="week">
                        {{ week }}
                      </option>
                    </select>
                  </div>
                  <div>
                    по
                  </div>
                  <div>
                    <select v-model="startWeek" class="uk-select tm-form-small">
                      <option v-for="week in weekRange" :key="week" :value="week">
                        {{ week }}
                      </option>
                    </select>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!--таблицы в табах-->
          <ul class="uk-switcher uk-background-muted">
            <!--таблица по неделям-->
            <li>
              <ReportTable tab="weeks" :reports="reports"  :loading="loading"/>
            </li>
            <!--таблица по месяцам-->
            <li>
              <ReportTable tab="months" :reports="reports"  :loading="loading" />
            </li>
          </ul>
        </div>

        <hr class="uk-margin-xlarge"/>
        <!--Средняя задержка выполнения заказов (awe_delay)-->
        <div class="uk-margin uk-animation-slide-bottom-small">
          <div class="uk-grid">
            <div class="uk-width-expand">
              <div class="tm-admin-report-title">
                Средняя задержка выполнения заказов
              </div>
            </div>
            <div class="uk-width-large">
              <div>
                <DatepickerDialog
                    :dateTimePeriod=dateTimeAweDelayPeriod
                    :choosenPeriod.sync=choosenAweDelayPeriod
                    :getPeriod=getPeriod
                    :todayDate=todayDate />
              </div>
            </div>
          </div>
          <div class="uk-margin-top">
            <CanvasJS v-if="this.chartAweDelayOptions.options" :options="chartAweDelayOptions.options" :style="chartAweDelayOptions.styleOptions"/>
          </div>
        </div>

        <hr class="uk-margin-xlarge"/>
        <!--Задержки выполнения заказов-->
        <div class="uk-margin uk-animation-slide-bottom-small">
          <div class="uk-grid">
            <div class="uk-width-expand">
              <div class="tm-admin-report-title">
                Задержки выполнения заказов
              </div>
            </div>
            <div class="uk-width-large">
              <div>
                <DatepickerDialog
                    :dateTimePeriod=dateTimeDelayPeriod
                    :choosenPeriod.sync=choosenDelayPeriod
                    :getPeriod=getPeriod
                    :todayDate=todayDate />
              </div>
            </div>
          </div>
          <div class="uk-margin-top">
            <CanvasJS v-if="this.chartDelayOptions.options" :options="chartDelayOptions.options" :style="chartDelayOptions.styleOptions"/>
          </div>
        </div>

        <hr class="uk-margin-xlarge"/>
        <!--Средний показатель качества (awe_quaility)-->
        <div class="uk-margin uk-animation-slide-bottom-small">
          <div class="uk-grid">
            <div class="uk-width-expand">
              <div class="tm-admin-report-title">
                Средний показатель качества
              </div>
            </div>
            <div class="uk-width-large">
              <div>
                <DatepickerDialog
                    :dateTimePeriod=dateTimeAweQuailityPeriod
                    :choosenPeriod.sync=choosenAweQuailityPeriod
                    :getPeriod=getPeriod
                    :todayDate=todayDate />
              </div>
            </div>
          </div>
          <div class="uk-margin-top">
            <CanvasJS v-if="this.chartAweQuailityOptions.options" :options="chartAweQuailityOptions.options" :style="chartAweQuailityOptions.styleOptions"/>
          </div>
        </div>

        <hr class="uk-margin-xlarge"/>
        <!--Оценки по заказам-->
        <div class="uk-margin uk-animation-slide-bottom-small">
          <div class="uk-grid">
            <div class="uk-width-expand">
              <div class="tm-admin-report-title">
                Оценки по заказам
              </div>
            </div>
            <div class="uk-width-large">
              <div>
                <DatepickerDialog
                    :dateTimePeriod=dateTimeRatingPeriod
                    :choosenPeriod.sync=choosenRatingPeriod
                    :getPeriod=getPeriod
                    :todayDate=todayDate />
              </div>
            </div>
          </div>
          <div class="uk-margin-top">
            <CanvasJS v-if="this.chartRatingOptions.options" :options="chartRatingOptions.options" :style="chartRatingOptions.styleOptions"/>
          </div>
        </div>

      </div>
    </div>

    <!--модалка списка заказов-->
    <div id="modal-detail" class="tm-modal-center">
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical_" style="padding: 0;width: 400px;">
        <button class="uk-modal-close-outside uk-icon uk-close" type="button">
          <svg width="26" height="26" viewBox="0 0 26 26"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="25" y2="25"></line><line fill="none" stroke="#000" stroke-width="1.1" x1="25" y1="1" x2="1" y2="25"></line></svg>
        </button>
        <div class="tm-green-list uk-text-left">
          <div class="tm-scheduletable-dropdown-box1" style="width: 400px;">
            <!--шапка-->
            <div class="tm-scheduletable-dropdown-list-head" v-if="this.dataTooltipDetail.length">
              <div class="uk-grid uk-grid-collapse" data-uk-grid>
                <div class="uk-width-expand">
                  <div class="tm-scheduletable-dropdown-list-cell">
                    {{ this.dataPoint.label }}
                    <!--{{ this.dataPoint.x }}  // 0,1,2...-->
                  </div>
                </div>
                <div class="uk-width-auto">
                  <div class="tm-scheduletable-dropdown-list-cell">
                    {{ this.dataSeries.name }}: {{ this.dataTooltipDetail.length }} заказа ({{ this.dataPoint.y }}%)
                  </div>
                </div>
              </div>
              <hr class="uk-margin-xsmall">
              <div class="uk-grid uk-grid-collapse">
                <div class="uk-width-expand">
                  <div data-uk-tooltip="" class="tm-scheduletable-dropdown-list-cell uk-text-left">
                    Номер заказа
                  </div>
                </div>
                <div class="tm-scheduletable-dropdown-list-width-small">
                  <div class="uk-display-inline-block uk-link-reset" data-uk-tooltip="title: Сортировка по значению">
                    <span class="uk-icon" @click="sortByValue('asc')">
                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                        <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                      </svg>
                    </span>
                    <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="sortByValue('desc')">
                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                        <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                      </svg>
                    </span>
                  </div>
                  <div data-uk-tooltip="" class="tm-scheduletable-dropdown-list-cell">
                    <i class="md-icon md-icon-font tm-scheduletable-icon md-theme-default">schedule</i>
                  </div>
                </div>
              </div>
            </div>
            <!--список-->
            <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable uk-background-muted" style="max-height: max-content;height: 430px;">
              <a :href="'#' + tooltip.order_id" @click="selectOrder(tooltip.order_id)" class="uk-display-block tm-link-admin-report" v-for="(tooltip, index) in sortedDataTooltipDetail" :key="index">
                <div class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list uk-text-small">
                  <div class="uk-width-expand">
                      <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold"
                           :style="{ 'text-decoration': (dataSeries.source === 'delay' && index === 0) ? 'line-through' : '', 'color': (dataSeries.source === 'delay' && index === 0) ? 'red' : '' }">
                      {{ tooltip.order_id }}
                    </div>
                  </div>
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ Math.round(tooltip.value) }}
                    </div>
                  </div>
                </div>
              </a>
              <div class="uk-padding uk-text-center" v-if="!this.dataTooltipDetail.length">
                нет данных
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Просмотр заказа-->
    <md-dialog
        :md-active.sync="showDialogOrder"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report tm-dialog-admin-order-history">
      <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeOrderView()">
        <span class="material-icons">close</span>
      </a>
      <div>
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-1-2">
            <v-tabs v-model="tabInfo">
              <v-tab class="uk-background-muted">
                {{ local_page_keys.tab_title_history_order}}
              </v-tab>
              <v-tab class="uk-background-muted">
                {{ local_page_keys.tab_title_info_order}}
              </v-tab>
            </v-tabs>
          </div>
          <div class="uk-width-1-2 uk-text-center">
            <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
              <div>
                <a href="#"
                   :disabled="activeOrderKey <= 0"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                   role="button"
                   data-uk-tooltip="title: Предыдущий заказ"
                   @click="prevOrder">
                  <span class="material-icons">chevron_left</span>
                </a>
              </div>
              <div>
                <a href="#"
                   :disabled="activeOrderKey >= (activeOrders.length-1)"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                   role="button"
                   data-uk-tooltip="title: Следующий заказ"
                   @click="nextOrder">
                  <span class="material-icons">chevron_right</span>
                </a>
              </div>
              <div>
                <button type="button"
                        @click="orderSignedUrl2Clipboard"
                        style="padding: 0 5px;"
                        class="uk-icon uk-link-text" data-uk-tooltip="title: Создать ссылку на заказ для просмотра">
                  <md-icon>content_copy</md-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-tabs-items v-model="tabInfo">
        <v-tab-item style="min-height: 600px; max-height: 90vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div v-if="loadingOrderView">
                <v-progress-circular
                    :width="2"
                    indeterminate
                    style="color: forestgreen"></v-progress-circular>
              </div>
              <div class="uk-position-relative tm-modal-page">
                <div class="uk-grid uk-flex-middle" data-uk-grid>
                  <div class="uk-width-auto">
                    <h4>{{ this.local_page_keys.order_number }}: {{ currendOrderId }}</h4>
                  </div>
                </div>
                <div class="uk-margin" v-if="!activeOrderReload">
                  <OrderView @orderInfo="handleOrderInfo($event)"></OrderView>
                </div>
                <hr class="uk-margin-medium">
                <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
                <prev-orders-block-for-admin :currentOrderId="currendOrderId"></prev-orders-block-for-admin>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item style="min-height: 600px; max-height: 90vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div class="uk-padding uk-position-relative tm-modal-page">
                <div class="text-center">
                  <md-dialog-title>
                    {{ local_page_keys.order_history_info_dialog_title }}№ {{ modal_info.order_number }}
                  </md-dialog-title>
                </div>
                <md-dialog-content>
                  <div v-if="loadingOrderHistoryInfo">
                    <v-progress-circular
                        :width="2"
                        indeterminate
                        style="color: forestgreen"></v-progress-circular>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('info_table')" class="uk-margin">
                    <md-table>
                      <md-table-row>
                        <md-table-head v-for="header of headersInfoTable" :key="header.id" :label="header.text">
                          {{ header.text }}
                        </md-table-head>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell v-for="header of headersInfoTable" :key="header.id">
                          <template v-if="(header.value === 'last_retoucher' || header.value === 'last_pro_retoucher')">
                            {{ modal_info.info_table[header.value] === '' ? modal_info.info_table[header.value] : modal_info.info_table[header.value] ? modal_info.info_table[header.value].name : '-'}}
                          </template>
                          <template v-else>
                            {{ modal_info.info_table[header.value] }}
                          </template>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('particular_table')" class="uk-margin">
                    <div class="text-center" v-if="!showParticularInfoTable">
                      <button class="btn btn-outline-primary" @click="showParticularInfoTable = !showParticularInfoTable">
                        {{ local_page_keys.modal_button_show_particular_table }}
                      </button>
                    </div>
                    <div v-else>
                      <div class="text-center">
                        <button class="btn btn-outline-dark" @click="showParticularInfoTable = !showParticularInfoTable">
                          {{ local_page_keys.modal_button_hide_particular_table }}
                        </button>
                      </div>
                      <md-table>
                        <md-table-row>
                          <md-table-head v-for="header of headersParticularInfoTable" :key="header.id" :label="header.text">
                            {{ header.text }}
                          </md-table-head>
                        </md-table-row>
                        <md-table-row v-for="item of sortByDate(modal_info.particular_table)" :key="item.id">
                          <md-table-cell v-for="header of headersParticularInfoTable" :key="header.id">
                            {{ item[header.value] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </md-dialog-content>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </md-dialog>
  </div>
</template>

<script>
import Preloader from "../Components/Preloader";
import ReportTable from "../Components/Admin/Reports/ReportTable";
import CanvasJS from '@/plugins/canvasjs/components/CanvasJSVueComponent';
import DatepickerDialog from "../Components/Admin/DatepickerDialog.vue";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";

const itemMappingForStackedGraph = {
  'star': {
    1: {'color': "#ff5858", name: "оценка 1*"},
    2: {'color': "#ff9933", name: "оценка 2*"},
    3: {'color': "#fdeb76", name: "оценка 3*"},
    4: {'color': "#6bc46e", name: "оценка 4*"},
    5: {'color': "#4caf50", name: "оценка 5*"},
  },
  'min': {
    '10': {'color': "#4caf50", name: " до 10 мин"},
    '20': {'color': "#6bc46e", name: "11-20 мин"},
    '40': {'color': "#fdeb76", name: "21-40 мин"},
    '80': {'color': "#ff9933", name: "41-80 мин"},
    '80more': {'color': "#ff5858", name: "80+ мин"},
  },
  'min_delay': {
    '05': {'color': "#4caf50", name: " до 0.5 мин"},
    '2': {'color': "#6bc46e", name: "0.5-2 мин"},
    '5': {'color': "#fdeb76", name: "2-5 мин"},
    '20': {'color': "#ff9933", name: "5-20 мин"},
    '20_more': {'color': "#ff5858", name: "20+ мин"},
  }
};

export default {
  components: {Preloader, ReportTable, CanvasJS, DatepickerDialog, OrderView,  PrevOrdersBlockForAdmin },
  data() {
    return {
      tabs: {
        'weeks': {name: 'По неделям', class: '', params: { filters: ['year', 'weeksRange']} },
        'months': {name: 'По месяцам', class: '', params: { filters: ['year']}},
      },
      activeTab: 'weeks',
      reports: {},
      weekRange:[],
      loading: false,
      local_page_keys: {},
      selectedYearForMonths: (new Date()).getFullYear(),
      selectedYearForWeeks: (new Date()).getFullYear(),
      startWeek: '',
      endWeek: '',
      reportsDay: {
        'aweQuaility': {},
        'aweDelay': {},
        //'aweSpeed': {},
        'rating': {},
        //'speed': {},
        'delay': {},
      },
      choosenPeriod: [],
      todayDate: '',
      chartAweQuailityOptions: {},
      chartAweDelayOptions: {},
      chartAweSpeedOptions: {},
      chartRatingOptions: {},
      chartDelayOptions: {},
      chartSpeedOptions: {},
      choosenAweQuailityPeriod: [],
      choosenAweDelayPeriod: [],
      choosenAweSpeedPeriod :[],
      choosenRatingPeriod :[],
      choosenDelayPeriod :[],
      choosenSpeedPeriod :[],
      dataTooltipDetail: {},
      dataPoint: {
        'label': '',
        'x':'',
        'y':'',
      },
      dataSeries: {
        'name':''
      },
      showDialogOrder: false,
      currendOrderId: null,
      activeOrderReload: false,
      loadingOrderView: true,
      loadingOrderHistoryInfo: true,
      activeOrderInfo: null,
      tabInfo: null,
      activeOrders: [],
      activeOrderKey: null,
      modal_info: {},
      headersInfoTable: [],
      headersParticularInfoTable: [],
      showParticularInfoTable: false,
      sortOrderDataTooltipDetail: 'desc',
    };
  },
  watch: {
    selectedYearForMonths(newValue) {
      this.getAdminReport(false);
    },
    selectedYearForWeeks(newValue) {
      this.startWeek = '';
      this.endWeek = '';
      this.getAdminReport();

    },
    startWeek(newValue, oldValue) {
      if (oldValue && newValue)
       this.getAdminReport(false);
    },
    endWeek(newValue, oldValue) {
      if (oldValue && newValue)
        this.getAdminReport(false);
    },
    choosenAweSpeedPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('AweSpeed')
    },
    choosenAweQuailityPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('AweQuaility')
    },
    choosenAweDelayPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('AweDelay')
    },
    choosenRatingPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('Rating')
    },
    choosenDelayPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('Delay')
    },
    choosenSpeedPeriod(newValue, oldValue){
      if (newValue != oldValue && newValue.length > 1)
        this.getAdminDayReport('Speed')
    },
  },
  methods: {
    async getAdminReport(initWeekRange = true) {
      //this.loading = true;
      this.reports = {};

      let params = {
        tab: this.activeTab,
        startWeek: this.startWeek,
        endWeek: this.endWeek,
        year: this.activeTab === 'weeks' ? this.selectedYearForWeeks : this.selectedYearForMonths
      }

      await this.$store.dispatch('adminReports/adminReportsList', params);
      let response = await this.$store.getters['adminReports/adminReportsList'];

      if (typeof response === 'object') {
        this.reports = response.data;
        if (this.activeTab === 'weeks') {
          if (initWeekRange) {
            this.weekRange = response.weekRange;
            this.initWeekRange();
          }
        }
      } else {
        alert("error");
      }
      this.loading = false;
    },
    async changeTab(key) {
      this.activeTab = key;
      await this.getAdminReport(false);
    },
    initWeekRange() {
      if (this.weekRange && this.weekRange.length > 0) {
        this.startWeek = this.weekRange[0];
        this.endWeek = this.weekRange[this.weekRange.length - 1]
      }
    },
    initPeriod() {
      let currentDate = new Date();
      let firstDayCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      let lastDayPrevMonth = new Date(firstDayCurrentMonth);
      lastDayPrevMonth.setDate(lastDayPrevMonth.getDate());

      let formattedDateStart = lastDayPrevMonth.getFullYear() + '-' +
          ((lastDayPrevMonth.getMonth() + 1) < 10 ? '0' : '') + (lastDayPrevMonth.getMonth() + 1) + '-' +
          (lastDayPrevMonth.getDate() < 10 ? '0' : '') + lastDayPrevMonth.getDate();

      let formattedDateEnd = currentDate.getFullYear() + '-' +
          ((currentDate.getMonth() + 1) < 10 ? '0' : '') + (currentDate.getMonth() + 1) + '-' +
          (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();

      this.choosenPeriod.push(formattedDateStart, formattedDateEnd);
      for (const chartKey in this.reportsDay) {
        if (this.reportsDay.hasOwnProperty(chartKey)) {
          const choosenMethodNamePeriod = `choosen${this.capitalizeFirstLetter(chartKey)}Period`;
          if (this[choosenMethodNamePeriod]) {
            this[choosenMethodNamePeriod].push(formattedDateStart, formattedDateEnd);
          }
        }
      }
    },
    initCharts() {
      for (const chartKey in this.reportsDay) {
        if (this.reportsDay.hasOwnProperty(chartKey)) {
          const chartOptionsMethodName = `getChart${this.capitalizeFirstLetter(chartKey)}Options`;
          if (this[chartOptionsMethodName]) {
            this[chartOptionsMethodName]();
          }
        }
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getPeriod() {
      this.choosenAweQuailityPeriod.sort();
      this.choosenAweSpeedPeriod.sort();
    },
    getDateTimeString(period) {
      return period.length > 0 ? `${period[0]}~${period[1]}` : '';
    },
    async getAdminDayReport(source = null) {
      if (source)
        this[`chart${source}Options`] = {}

      let params = {
        period: source === null ? this.choosenPeriod : this[`choosen${source}Period`],
      }
      await this.$store.dispatch('adminReports/adminDayReport', params);
      let response = await this.$store.getters['adminReports/adminDayReport'];
      if (typeof response === 'object') {
        if (source === null) {
          const responseData = response.data;
          for (const chartKey in this.reportsDay) {
            if (this.reportsDay.hasOwnProperty(chartKey)) {
              this.reportsDay[chartKey] = responseData;
            }
          }
        } else {
          let target = source[0].toLowerCase() + source.substring(1);
          this.reportsDay[target] = response.data;
          this[`getChart${source}Options`]()
        }
      } else {
        alert("error");
      }
      this.loading = false;
    },
    // label поле для оси Х , fieldY - для оси Y
    prepareData(source, label, fieldY) {
      let data;
      if (Array.isArray(this.reportsDay[source])) {
        data = this.reportsDay[source].map(item => ({
          label: item[label],
          y: Number(item[fieldY]),
        }));
      }
      return data;
    },
    //ожидаемые поля: 10_min 80more_min 2_star 0_star и т.д field это  min или star, range: ожидаемые значение (0,2.. или 10, 80more )
    prepareDataForStacked(source, field, range) {
      let data;
      if (Array.isArray(this.reportsDay[source])) {
        data = this.reportsDay[source];
        const dataPoint = [];

        data.forEach((item) => {
          range.forEach((i) => {
            const propName = `${i}_${field}`;
            dataPoint.push({label: item.day, originalName: i,  y: item[propName] || 0});
          });
        });

        const showToolTipOnClick = (e) => {
          this.dataSeries = e.dataSeries;
          this.dataPoint = e.dataPoint;
          this.dataTooltipDetail = {};
          this.dataTooltipDetail = this.prepareDataForStackedTooltip(source, field, e.dataPoint.label, e.dataPoint.originalName);
          this.showDetailModal();
          //e.chart.toolTip.showAtX(e.dataPoint.x,e.dataSeriesIndex);
        };

        return dataPoint.reduce((result, item) => {
          const existingItem = result.find((resultItem) => resultItem.originalName === String(item.originalName));
          if (existingItem) {
            existingItem.dataPoints.push({
              label: item.label,
              originalName: item.originalName,
              y: item.y,
              click: showToolTipOnClick,
            });
          } else {
            result.push({
              type: "stackedColumn100",
              originalName: String(item.originalName),
              name: String(itemMappingForStackedGraph[field][item.originalName].name), // здесь была засада без String)
              color: itemMappingForStackedGraph[field][item.originalName].color || "#10504E",
              showInLegend: "true",
              source:source,
              dataPoints: [
                {
                  label: item.label,
                  originalName: item.originalName,
                  y: Number(item.y),
                  click: showToolTipOnClick,
                },
              ],
            });
          }
          return result;
        }, []);
      }
    },
    prepareDataForStackedTooltip(source, suffix, day, field) {
      let data;
      if (Array.isArray(this.reportsDay[source])) {
        data = this.reportsDay[source];
        let foundItem = data.find(item => item.day === day);
        let targetItem = field + '_' + suffix + '_json';
        let result = foundItem ? JSON.parse(foundItem[targetItem]) : null;
        let value;

        switch (source) {
          case 'speed':
          case 'delay':
            value = 'time_for_order';
            break;
          case 'rating':
            value = 'like_by_client';
            break;
          default:
            value = order.order_id;
        }

        return result.map(order => {
          return {...order, value: order[value]};
        });
      }
    },
    getChartAweQuailityOptions() {
      this.chartAweQuailityOptions = {
        options: {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            //text: "Средний показатель качества"
          },
          axisX: {
            labelFontSize: 14,
          },
          axisY: {
            //maximum: 5000,
            minimum:0,
            title: "Количество заказов",
            titleFontColor: "#4caf50",
            labelFontColor: "#4caf50",
            lineColor: "#4caf50",
            tickColor: "#4caf50",
            gridColor: "#e0e0e0",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          axisY2: {
           // maximum: 100,
            minimum:0,
            title: "AWE",
            valueFormatString: "#,##" + "%",
            titleFontColor: "#f07113",
            labelFontColor: "#f07113",
            lineColor: "#f07113",
            tickColor: "#f07113",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          toolTip: {
            shared: true
          },
          data: [
            {
              type: "column",
              name: "Количество заказов",
              color: "#4caf50",
              dataPoints: this.prepareData('aweQuaility', 'day', 'numbers_orders')
            },
            {
              type: "line",
              axisYType: "secondary",
              name: "Средний показатель качества",
              color: "#f07113",
              dataPoints: this.prepareData('aweQuaility', 'day', 'awe_quaility')
            }
          ]
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    getChartAweDelayOptions() {
      this.chartAweDelayOptions = {
        options: {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            //text: "Средний показатель качества"
          },
          axisX: {
            labelFontSize: 14,
          },
          axisY: {
            //maximum: 5000,
            minimum:0,
            title: "Количество заказов",
            titleFontColor: "#4caf50",
            labelFontColor: "#4caf50",
            lineColor: "#4caf50",
            tickColor: "#4caf50",
            gridColor: "#e0e0e0",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          axisY2: {
            // maximum: 100,
            minimum:0,
            title: "AWE",
            valueFormatString: "#,##" + "%",
            titleFontColor: "#f07113",
            labelFontColor: "#f07113",
            lineColor: "#f07113",
            tickColor: "#f07113",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          toolTip: {
            shared: true
          },
          data: [
            {
              type: "column",
              name: "Количество заказов",
              color: "#4caf50",
              dataPoints: this.prepareData('aweDelay', 'day', 'numbers_orders')
            },
            {
              type: "line",
              axisYType: "secondary",
              name: "Средняя задержка выполнения заказов",
              color: "#f07113",
              dataPoints: this.prepareData('aweDelay', 'day', 'awe_delay')
            }
          ]
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    getChartAweSpeedOptions() {
      this.chartAweSpeedOptions = {
        options: {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            //text: "Средняя скорость выполнения заказов"
          },
          axisX: {
            labelFontSize: 14,
          },
          axisY: {
            //maximum: 5000,
            minimum:0,
            title: "Количество заказов",
            titleFontColor: "#4caf50",
            labelFontColor: "#4caf50",
            lineColor: "#4caf50",
            tickColor: "#4caf50",
            gridColor: "#e0e0e0",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          axisY2: {
            //  maximum: 50,
            minimum:0,
            title: "AWE",
            valueFormatString: "# мин",
            titleFontColor: "#f07113",
            labelFontColor: "#f07113",
            lineColor: "#f07113",
            tickColor: "#f07113",
            labelFontSize: 14,
            titleFontSize: 20,
          },
          toolTip: {
            shared: true
          },
          data: [
            {
              type: "column",
              name: "Количество заказов",
              color: "#4caf50",
              dataPoints: this.prepareData('aweSpeed', 'day', 'numbers_orders')
            },
            {
              type: "line",
              axisYType: "secondary",
              name: "Средняя скорость выполнения заказов",
              color: "#f07113",
              dataPoints: this.prepareData('aweSpeed', 'day', 'awe_speed')
            }
          ]
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    getChartRatingOptions() {
      this.chartRatingOptions = {
        chart: null,
        options: {
          theme: "light2",
          title: {
            //text: "Оценки по заказам"
          },
          axisX: {
            labelTextAlign: "center",
            labelFontSize: 14,
          },
          axisY: {
            labelFontSize: 14,
          },
          toolTip: {
            //enabled: false,
            shared: false,
            contentFormatter: function (e) {
              var content = " ";
              for (var i = 0; i < e.entries.length; i++) {
                content += e.entries[i].dataPoint.label +"<br/>";
                content +=  '(' +e.entries[i].dataSeries.name + ')'+ "<br/>";
                content += "<strong>" + e.entries[i].dataPoint.y + "%</strong>";
                content += "<br/>";
              }
              return content;
            }
          },
          data: this.prepareDataForStacked('rating', 'star', ['1', '2', '3', '4', '5'])
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    getChartDelayOptions() {
      this.chartDelayOptions = {
        chart: null,
        options: {
          theme: "light2",
          title: {
          },
          axisX: {
            labelTextAlign: "center",
            labelFontSize: 14,
          },
          axisY: {
            labelFontSize: 14,
          },
          toolTip: {
            //enabled: false,
            shared: false,
            contentFormatter: function (e) {
              var content = " ";
              for (var i = 0; i < e.entries.length; i++) {
                content += e.entries[i].dataPoint.label +"<br/>";
                content +=  '(' +e.entries[i].dataSeries.name + ')'+ "<br/>";
                content += "<strong>" + e.entries[i].dataPoint.y + "%</strong>";
                content += "<br/>";
              }
              return content;
            }
          },
          data: this.prepareDataForStacked('delay', 'min_delay', ['05', '2', '5', '20', '20_more'])
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    getChartSpeedOptions() {
      this.chartSpeedOptions = {
        chart: null,
        options: {
          theme: "light2",
          title: {
            //text: "Скорость выполнения заказов"
          },
          axisX: {
            labelTextAlign: "center",
            labelFontSize: 14,
          },
          axisY: {
             labelFontSize: 14,
          },
          toolTip: {
         //   enabled: false,
            shared: false,
            contentFormatter: function (e) {
              var content = " ";
              for (var i = 0; i < e.entries.length; i++) {
                content += e.entries[i].dataPoint.label +"<br/>";
                content +=  '(' +e.entries[i].dataSeries.name + ')'+ "<br/>";
                content += "<strong>" + e.entries[i].dataPoint.y + "%</strong>";
                content += "<br/>";
              }
              return content;
            }
          },
          data: this.prepareDataForStacked('speed', 'min', ['10', '20', '40', '80', '80more'])
        },
        styleOptions: {
          width: "100%",
          height: "500px"
        }
      };
    },
    showDetailModal() {
      UIkit.modal("#modal-detail").show();
    },
    hideDetailModal() {
      UIkit.modal("#modal-detail").hide();
    },
    async selectOrder(orderId) {
        this.activeOrders = this.sortedDataTooltipDetail.map((order) => {
          return order.order_id ?? null;
        });
      this.activeOrderKey = this.activeOrders.indexOf(orderId);
      await this.openOrderView(orderId);
    },
    async openOrderView(order_id) {
      let orderId = Number(order_id)
      this.hideDetailModal();
      this.activeOrderReload = true;
      this.loadingOrderView = true;
      await this.$store.dispatch('order/setViewOrderId', orderId);
      this.currendOrderId = orderId;
      this.showDialogOrder = true;
      this.activeOrderReload = false;
      this.loadingOrderView = false;
      this.showOrderHistory(orderId)
      location.hash = orderId;
    },
    async showOrderHistory(order_id) {
      this.loadingOrderHistoryInfo = true;
      await this.$store.dispatch('adminOrdersHistory/orderHistoryInfo', {order_id});
      let data = await this.$store.getters['adminOrdersHistory/orderHistoryInfo'];
      if (typeof data === 'object') {
        if (Object.keys(data).includes('info_table')) {
          this.modal_info['info_table'] = data.info_table;
        }
        if (Object.keys(data).includes('particular_table') && data.particular_table.length > 0) {
          this.modal_info['particular_table'] = data.particular_table;
        }
        this.modal_info['order_number'] = this.modal_info.info_table['order_number'];
        this.loadingOrderHistoryInfo = false;
      } else {
        this.loadingOrderHistoryInfo = false;
        this.modal_info['error'] =  data;
      }
    },
    closeOrderView() {
      this.showDialogOrder = false;
      this.activeOrderInfo = null;
      this.showDetailModal();
    },
    orderSignedUrl2Clipboard() {
      let result = {
        message: "Что-то пошло не так. Формирование ссылки невозможно",
        pos: 'top-center',
        status: 'danger',
        timeout: 2500
      };
      let url = '';

      if (this.currendOrderId != null && Object.keys(this.activeOrderInfo).includes('order_url_signature')) {
        url = this.currendOrderId.order_number + '-' + this.currendOrderId.order_url_signature;
        url = window.location.protocol + '//' + window.location.host + '/order/' + url;
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(input);
        if (successful)
          result = {message: "Ссылка на заказ скопирована в буфер", pos: 'top-center', status: 'success', timeout: 2500}
      }
      UIkit.notification(result);
    },
    handleOrderInfo(e) {
      this.activeOrderInfo = e;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrderView(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrderView(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    getHeaders() {
      this.headersInfoTable = [
        {text: this.local_page_keys.modal_info_table_header_order_id, value: 'order_id'},
        {text: this.local_page_keys.modal_info_table_header_order_number, value: 'order_number'},
        {text: this.local_page_keys.modal_info_table_header_last_retoucher, value: 'last_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_last_pro_retoucher, value: 'last_pro_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_created_at, value: 'created_at'},
        {text: this.local_page_keys.modal_info_table_header_updated_at, value: 'updated_at'},
      ];
      this.headersParticularInfoTable = [
        {text: this.local_page_keys.modal_particular_info_table_header_order_date, value: 'date'},
        {text: this.local_page_keys.modal_particular_info_table_header_order_new_status, value: 'new_status'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_role, value: 'user_role'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_email, value: 'user_email'},

      ];
    },
    sortByDate(array) {
      let sortedArray = array.sort(function (a, b) {
        let firstDate = new Date(a.date);
        let secondDate = new Date(b.date);
        return firstDate - secondDate;
      })
      return sortedArray;
    },
    sortByValue(order) {
      this.sortOrderDataTooltipDetail = order;
    },
  },
  computed: {
    dateTimeAweQuailityPeriod() {
      return this.getDateTimeString(this.choosenAweQuailityPeriod);
    },
    dateTimeAweDelayPeriod() {
      return this.getDateTimeString(this.choosenAweDelayPeriod);
    },
    dateTimeAweSpeedPeriod() {
      return this.getDateTimeString(this.choosenAweSpeedPeriod);
    },
    dateTimeRatingPeriod() {
      return this.getDateTimeString(this.choosenRatingPeriod);
    },
    dateTimeDelayPeriod() {
      return this.getDateTimeString(this.choosenDelayPeriod);
    },
    dateTimeSpeedPeriod() {
      return this.getDateTimeString(this.choosenSpeedPeriod);
    },
    sortedDataTooltipDetail() {
      return (this.dataTooltipDetail.length > 0) ? this.dataTooltipDetail.slice().sort((a, b) => {
        const multiplier = this.sortOrderDataTooltipDetail === 'asc' ? 1 : -1;
        return (a.value - b.value) * multiplier;
      }) : {};
    },
  },
  async created() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('admin_reports'), await this.$filtergetLocalisationPage('admin_orders_history'), await this.$filtergetLocalisationPage('pro_retoucher_progress_report'));
    await this.getAdminReport();
    this.initPeriod()
    await this.getAdminDayReport();
    this.initCharts();
    this.getHeaders();
  },
  destroyed() {
   this.hideDetailModal();
  }
}
</script>

<style>
.tm-link-admin-report:visited .tm-scheduletable-dropdown-list-cell,
.tm-link-admin-report:focus .tm-scheduletable-dropdown-list-cell {
  background-color: #5b7f5c !important;
}
</style>